import { Flex, Icon, useColorMode, useColorStyle } from '@tonic-one/react';
import { SortDownIcon, SortUpIcon } from '@tonic-one/react-icons';
import React, { useMemo } from 'react';

import SmartTooltip from '../SmartTooltip';

export default function SortableHeader(props: any) {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { label, headerKey, currentSortKey, changeSortKey, ...rest } = props;

  const isSelected = useMemo(() => {
    if (typeof headerKey !== 'string' || typeof currentSortKey !== 'string') {
      return false;
    }
    return headerKey.replace('-', '') === currentSortKey.replace('-', '');
  }, [headerKey, currentSortKey]);

  const icon = useMemo(() => {
    if (currentSortKey[0] === '-') {
      return <Icon as={SortDownIcon} size="5x" />;
    } else {
      return <Icon as={SortUpIcon} size="5x" />;
    }
  }, [currentSortKey]);

  const toggle = () => {
    const flag = currentSortKey[0];
    if (flag === '-') {
      return changeSortKey(currentSortKey.slice(1));
    } else {
      return changeSortKey(`-${currentSortKey}`);
    }
  };
  const clickSort = () => {
    changeSortKey(headerKey);
  };

  if (isSelected) {
    return (
      <Flex
        cursor="pointer"
        onClick={toggle}
        color={colorStyle.color.primary}
        {...rest}
      >
        <SmartTooltip>{label}</SmartTooltip>
        {icon}
      </Flex>
    );
  } else {
    return (
      <Flex
        cursor="pointer"
        onClick={() => {
          clickSort();
        }}
        {...rest}
      >
        <SmartTooltip>{label}</SmartTooltip>
      </Flex>
    );
  }
}
